import { MenuItem, styled } from "@mui/material";
import { BaseInputPropsType } from "../../../types/app.type";

export const BaseOption = styled(MenuItem)<BaseInputPropsType>(({ colour, fontWeight }) => {
    return {
        fontFamily: "Inter",
        fontWeight: fontWeight || 500,
        fontSize: "16px",
        lineHeight: "normal",
        color: colour || "#373737",
        padding: "calc(var(--basic-padding)/2)",
    }
})